export default __webpack_public_path__ + "media/Raleway-Medium.1af9f1e9.ttf";